import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function AdminPanel({ onImageUpload, cards, onSaveLayout }) {
  const { isAdmin, logoutAdmin } = useAuth();
  const [isExpanded, setIsExpanded] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(null);

  if (!isAdmin) return null;

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    setUploadProgress(0);
    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert(`${file.name} is not an image file`);
        continue;
      }

      // Validate file size (5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        alert(`${file.name} is too large (max 5MB)`);
        continue;
      }

      try {
        await onImageUpload(file);
        setUploadProgress((i + 1) / files.length * 100);
      } catch (error) {
        console.error(`Failed to upload ${file.name}:`, error);
        alert(`Failed to upload ${file.name}`);
      }
    }
    
    setTimeout(() => setUploadProgress(null), 2000);
  };

  const exportData = () => {
    const exportData = {
      cards: cards,
      exportDate: new Date().toISOString(),
      version: '1.0'
    };
    
    const blob = new Blob([JSON.stringify(exportData, null, 2)], {
      type: 'application/json'
    });
    
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `card-collection-${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="admin-panel">
      <button 
        className="admin-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        Admin {isExpanded ? '−' : '+'}
      </button>
      
      {isExpanded && (
        <div className="admin-controls">
          <div className="admin-section">
            <h4>Upload Images</h4>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={handleFileUpload}
              className="file-input"
            />
            {uploadProgress !== null && (
              <div className="progress-bar">
                <div 
                  className="progress-fill"
                  style={{ width: `${uploadProgress}%` }}
                />
                <span>{Math.round(uploadProgress)}%</span>
              </div>
            )}
          </div>

          <div className="admin-section">
            <h4>Data Management</h4>
            <button onClick={onSaveLayout} className="admin-btn">
              Save Layout
            </button>
            <button onClick={exportData} className="admin-btn">
              Export Collection
            </button>
          </div>

          <div className="admin-section">
            <h4>Collection Stats</h4>
            <p>Cards: {Array.isArray(cards) ? cards.length : Object.keys(cards || {}).length}</p>
          </div>

          <div className="admin-section">
            <button onClick={logoutAdmin} className="admin-btn danger">
              Exit Admin Mode
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
